
  <ion-header *ngIf="!isEmbed">
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button (click)="cancelChanges()" color="warning">{{ 'Close' | translate }}</ion-button>
      </ion-buttons>
      <ion-button (click)="setToNull()" fill="clear" color="danger" *ngIf="workingSelectedValues">
        <ion-icon name="trash"></ion-icon><ion-label>{{ 'Cancel the selection' | translate }}</ion-label>
      </ion-button>
      <ion-buttons slot="end">
        <ion-button (click)="confirmChanges()">{{ 'Validate' | translate }}</ion-button>
      </ion-buttons>
    </ion-toolbar>
    <ion-toolbar *ngIf="enableFilter">
      <ion-searchbar placeholder="{{ 'Search' | translate }}" [debounce]="500" (ionInput)="searchbarInput($event)" #searchBar></ion-searchbar>
    </ion-toolbar>
  </ion-header>

  <ion-content class="ion-padding" *ngIf="!isEmbed">
    <ion-list id="modal-list" [inset]="true">
      <ion-item lines="none" *ngIf="items.length == 0 && enableFilter && searchBar">
        <ion-label *ngIf="searchBar.value == null || searchBar.value == ''">{{ 'Enter your keywords to launch the search.' | translate }}</ion-label>
        <ion-label *ngIf="searchBar.value != null && searchBar.value != ''">{{ 'We found no results for this research.' | translate }}</ion-label>
      </ion-item>
      <ion-item *ngFor="let item of items; trackBy: trackItems"  (click)="radioGroupChange(item.id)">
        <img *ngIf="item.icon != null" src="{{item.icon}}" style="margin-right: 1em; width: 1em;" slot="start">
        <span *ngIf="item.prefix != null" [innerHTML]="item.prefix" style="margin-right: 1em; width: 1em;"></span>
        <ion-label [innerHTML]="item.name"></ion-label>
        <ion-checkbox slot="end"
          [value]="item.id" [checked]="item.id == workingSelectedValues"
        ></ion-checkbox>
      </ion-item>
    </ion-list>
  </ion-content>

  <ion-footer *ngIf="!isEmbed">
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button (click)="cancelChanges()" color="warning">{{ 'Close' | translate }}</ion-button>
      </ion-buttons>
      <ion-button (click)="setToNull()" fill="clear" color="danger">
        <ion-icon name="trash"></ion-icon><ion-label>{{ 'Cancel the selection' | translate }}</ion-label>
      </ion-button>
      <ion-buttons slot="end">
        <ion-button (click)="confirmChanges()">{{ 'Validate' | translate }}</ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-footer>


<ng-container *ngIf="isEmbed">
  <ion-item lines="none" *ngIf="enableFilter">
    <ion-searchbar placeholder="{{ 'Search' | translate }}" [debounce]="100" (ionInput)="searchbarInput($event)" #searchBar></ion-searchbar>
  </ion-item>
  <ion-list id="modal-list" [inset]="true" style="margin-top: 0;">
    <ion-item lines="none" *ngIf="items.length == 0 && enableFilter && searchBar">
      <ion-label *ngIf="searchBar.value == null || searchBar.value == ''">{{ 'Enter your keywords to launch the search.' | translate }}</ion-label>
      <ion-label *ngIf="searchBar.value != null && searchBar.value != ''">{{ 'We found no results for this research.' | translate }}</ion-label>
    </ion-item>
    <ion-item *ngFor="let item of items; trackBy: trackItems"  (click)="radioGroupChange(item.id)">
      <img *ngIf="item.icon != null" src="{{item.icon}}" style="margin-right: 1em; width: 1em;" slot="start">
      <span *ngIf="item.prefix != null" [innerHTML]="item.prefix" style="margin-right: 1em; width: 1em;"></span>
      <ion-label [innerHTML]="item.name"></ion-label>
      <ion-checkbox slot="end" [checked]="workingSelectedValues == item.id" [value]="item.id"></ion-checkbox>
    </ion-item>
  </ion-list>
</ng-container>